// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2H9QH","head":"Table_head__1Ti7x","col":"Table_col__1lbUK"};